import { Images } from '@/assets/images';
import { Theme } from '@/theme';
import styled from 'styled-components';

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const PopupContent = styled.div`
  position: absolute;
  top: 18%;
  width: 85%;
  margin: 16px;
  background-image: url(${Images.PopupBg});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 413px;
  padding: ${Theme.rems(143)} 24px 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 8%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 92px;
    height: 201px;
    background-image: url(${Images.Avatar});
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 4%;
  right: 4%;
  width: 35px;
  height: 35px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: #000;
    top: 50%;
    left: 50%;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const Title = styled.h1`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(32)};
  font-weight: ${Theme.font.weight.bold};
  text-align: center;
`;

export const Description = styled.p`
  font-size: ${Theme.rems(16)};
  line-height: 1.5;
  text-align: center;
  margin-bottom: 19px;
  color: ${Theme.color.darkGrey};
`;

export const Button = styled.button`
  font-family: ${Theme.font.family.speedeeCondensed};
  background-color: ${Theme.color.orange};
  border: none;
  border-radius: 50px;
  padding: 16px 32px;
  font-size: ${Theme.rems(22)};
  font-weight: ${Theme.font.weight.bold};
  width: 200px;
  color: ${Theme.color.black};
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.2s;
`;
